import { PessoaModel } from "api/cardapio/models/pessoa/pessoa-model";
import { create } from "zustand";
import { persist } from "zustand/middleware";

interface IPessoaUsuarioStore {
    pessoa: PessoaModel | undefined;
    empresaId: string;
    setPessoa: (pessoa: PessoaModel | undefined) => void;
}

export const usePessoaUsuarioStore = create<IPessoaUsuarioStore>()(
    persist((set) => ({
        pessoa: undefined,
        empresaId: '',
        setPessoa: (pessoa: PessoaModel | undefined) => set({ pessoa }),
        setEmpresaId: (empresaId: string) => set({ empresaId }),
    }), {
        name: 'pessoa-usuario',
    })
);